import {
  AccountFlagsItemResponse,
  AccountFlagsResponse,
  AccountResponse,
} from "../types";

export function getIsAiEnabled(
  account: Pick<AccountResponse, "is_ai_enabled"> | undefined,
  response?: AccountFlagsResponse,
): boolean {
  if (!account) {
    return false;
  }

  return Boolean(account.is_ai_enabled) && !getIsAiOptedOut(response);
}

export function getIsAiOptedOut(response?: AccountFlagsResponse): boolean {
  return isAccountFlagSet(response, "ai.opted_out");
}

export function getIsFieldCaptureEnabled(
  response?: AccountFlagsResponse,
): boolean {
  return isAccountFlagSet(response, "field_captures.enabled");
}

function isAccountFlagSet(
  response: AccountFlagsResponse | undefined,
  name: string,
): boolean {
  return (
    response?.flags?.items?.some(
      (flag: AccountFlagsItemResponse) => flag.name === name && flag.value,
    ) ?? false
  );
}
